"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.minimiseChat = exports.maximiseChat = exports.addMessage = exports.setState = undefined;

var _ChatActionTypes = require("../constants/action-types/ChatActionTypes");

var types = _interopRequireWildcard(_ChatActionTypes);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var setState = exports.setState = function setState(state) {
  return {
    type: types.SET_CHAT_STATE,
    payload: {
      state: state
    }
  };
};

var addMessage = exports.addMessage = function addMessage(playerName, playerId, text) {
  return {
    type: types.ADD_MESSAGE,
    payload: {
      playerName: playerName,
      playerId: playerId,
      text: text
    },
    meta: {
      shared: true
    }
  };
};

var maximiseChat = exports.maximiseChat = function maximiseChat() {
  return {
    type: types.MAXIMISE_CHAT
  };
};

var minimiseChat = exports.minimiseChat = function minimiseChat() {
  return {
    type: types.MINIMISE_CHAT
  };
};